import { apiClient } from './api'

export const notificationService = {
  getByUser: async (userId: string, params: {
    type?: string
    is_read?: boolean
    limit?: number
    offset?: number
  } = {}) => {
    return apiClient.get(`/notifications/user/${userId}`, { params })
  },

  getByRole: async (role: string, params: {
    type?: string
    is_read?: boolean
    limit?: number
    offset?: number
  } = {}) => {
    return apiClient.get(`/notifications/role/${role}`, { params })
  },

  markAsRead: async (id: string) => {
    return apiClient.put(`/notifications/${id}/read`)
  },

  markAllAsReadByUser: async (userId: string) => {
    return apiClient.put(`/notifications/user/${userId}/read-all`)
  },

  markAllAsReadByRole: async (role: string) => {
    return apiClient.put(`/notifications/role/${role}/read-all`)
  },

  getUnreadCountByUser: async (userId: string) => {
    return apiClient.get(`/notifications/user/${userId}/unread-count`)
  },

  getUnreadCountByRole: async (role: string) => {
    return apiClient.get(`/notifications/role/${role}/unread-count`)
  },

  delete: async (id: string) => {
    return apiClient.delete(`/notifications/${id}`)
  },

  create: async (data: { recipient_user_id?: string; recipient_role?: string; type: string; title: string; message: string; action_link?: string; metadata?: Record<string, unknown> }) => {
    return apiClient.post('/notifications', data)
  },
}
